// extracted by mini-css-extract-plugin
export default {"container":"checkbox-group__container___30Y5c"};